import { DbLoadInventoryByEan } from "../../../data/usecases/load-inventory-by-ean";
import { LoadInventoryByEan } from "../../../domain/usecases/load-inventory-by-ean";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbLoadInventoryByEan = (): LoadInventoryByEan => {
  return new DbLoadInventoryByEan(
    makeApiUrl("/inventory"),
    makeAuthorizeHttpClientDecorator()
  );
};
